(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  function initRails(root) {
    (root || document).querySelectorAll('[data-hh-rail]').forEach(function (rail) {
      var wrap = rail.parentElement;
      var prev = wrap.querySelector('[data-hh-prev]');
      var next = wrap.querySelector('[data-hh-next]');
      var step = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { var v = e.target.querySelector('video'); if (!v) return; if (e.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
        }, { threshold: 0.4 });
        rail.querySelectorAll('.hh-media').forEach(function (m) { vio.observe(m); });
      }
    });
  }
  function init(root) { initReveal(root); initRails(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); e.target.querySelectorAll('.hh-reveal').forEach(function (el) { el.classList.add('is-in'); }); });
})();
